import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import Toggle from 'react-toggle';
import { showModal } from '../../../../actions/ModalActions';
import { getRegistries, editRegistry } from '../../../../actions/website/entities/RegistryActions';
import { moveEntity, resetEntities, addEntity } from '../../../../actions/website/EntityActions';
import DragHandle from '../../../common/ui/DragHandle';
import EntityHeader from './EntityHeader';
import { togglePage } from '../../../../actions/website/PageActions';
import { fetchRegistry, updateRegistryPublish } from '../../../../actions/RegistryActions';
import fetchModuleGroup from '../../../../actions/ModuleGroupActions';


const Registry = SortableElement(({ registry, onEdit, onDelete }) => {
  const noPropagate = (e) => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
  };

  return (
    <div>
      <li className="sortable-item editable-entity" onClick={() => onEdit(registry)}>
        <div className="col-sm-1">
          <DragHandle tooltip="Drag to reorder" />
        </div>
        <div className="col-sm-8">
          <span className="title-v2">{registry.name}</span>
        </div>
        <div className="col-sm-3 entity-actions" onClick={noPropagate}>
          <button onClick={() => onEdit(registry)} title="Edit Registry" className="btn btn-icon with-tooltip no-tooltip-on-mobile" data-tooltip="Edit"><i className="glyphicon glyphicon-pencil" /></button>
          <button onClick={() => onDelete(registry)} title="Delete Registry" className="btn btn-icon with-tooltip no-tooltip-on-mobile" data-tooltip="Delete"><i className="glyphicon glyphicon-trash" /></button>
        </div>
      </li>
    </div>
  );
});

Registry.propTypes = {
  registry: PropTypes.shape({}).isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  index: PropTypes.number,
};


class Registries extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showVideo: false,
      registryPublished: false
    };
    this.toggleVideo = this.toggleVideo.bind(this);
    this.onToggleRegistryPublish = this.onToggleRegistryPublish.bind(this);
  }

  componentDidMount() {
    const { getRegistry, getRegistryEntities, getModules, hasRegistry } = this.props;
    if (hasRegistry) {
      getRegistry().then(() => this.setState({ registryPublished: this.props.registry.is_public }));
    }
    getRegistryEntities();
    getModules();
  }

  componentWillReceiveProps(nextProps) {
    const { registry } = this.props;
    if (registry.is_public !== nextProps.registry.is_public) {
      this.setState({
        registryPublished: nextProps.registry.is_public
      });
    }
  }

  componentWillUnmount() {
    const { unloadEntities } = this.props;
    unloadEntities();
  }

  onToggleRegistryPublish(e) {
    const { onToggleRegistryPublish, setShippingAddress, registry } = this.props;
    const newValue = e.target.checked;
    if (!registry.has_shipping_address) {
      setShippingAddress();
    } else {
      onToggleRegistryPublish(newValue);
    }
  }

  toggleVideo() {
    this.setState({ showVideo: true });
  }

  render() {
    const { registries, registry, orderedIds, openModal, onEdit, onDelete, page, hasRegistry, slug, themeKey, onPageToggle, moduleGroup } = this.props;
    const { registryPublished } = this.state;
    const registryActivated = registry.status === 'ACTIVE';

    const headerOptions = (
      <div className="registry-options margin-top">
        <button className="btn btn-secondary" onClick={openModal}>+ Add existing registry</button>
      </div>
    );

    return (
      <div className={`registry-cms-page ${registryActivated ? 'registry-activated' : 'registry-not-activated'}`}>
        {themeKey && (
          <EntityHeader onAdd={openModal} page={page} themeKey={themeKey} onPageToggle={onPageToggle} entityOptions={registryActivated ? headerOptions : null} />
        )}
        {!hasRegistry && (
          <div className="registry-marketing-module">
            {moduleGroup.moduleViews && (
              <div id="weddings-registry-marketing-module" className="row">
                {moduleGroup.moduleViews.map((moduleView, idx) => (
                  <div className="col-xs-12 marketing-module" key={idx}>
                    <a href={moduleView.link_path} rel="noopener noreferrer">
                      <img src={moduleView.images_by_dimension['440x510']} alt={moduleView.title} className="img-responsive" />
                    </a>
                  </div>
                ))}
              </div>
            )}
            <div className="registry-options margin-top">
              <button className="btn btn-secondary" onClick={openModal}>+ Add existing registry</button>
            </div>
          </div>
        )}
        {hasRegistry && (
          <div className="zola-registry has-zola margin-top clearfix">
            <h4 className="text-sans">Zola Registry</h4>
            <a href={`/registry/${slug}/edit`} className="margin-top text-button">Manage Your Registry &rsaquo;</a>
            <div className={`cta-section ${registryActivated ? '' : 'cta-section-bottom'}`}>
              {!registryActivated && (
                <a href="/onboard/new" className="btn btn-primary">Start Registry</a>
              )}
              {registryActivated && (
                <div>
                  <div className="toggle-registry-visible margin-top hidden-md hidden-lg">
                    <span>Visible to Guests? <div className="with-tooltip" data-tooltip="Ready to show off your registry? Switch the toggle to &quot;Yes&quot; and anyone will be able to see it. Not ready yet? Keep the toggle on &quot;No.&quot;"><i className="zolaicon zolaicon-info" /></div></span>
                    <div className="toggle-button-inline">
                      <Toggle
                        checked={registryPublished}
                        onChange={this.onToggleRegistryPublish}
                        className="toggle-small toggle-red"
                        icons={{ checked: <span className="toggle-label checked">Yes</span>, unchecked: <span className="toggle-label unchecked">No</span> }}
                      />
                    </div>
                  </div>
                  <div className="toggle-registry-visible margin-top hidden-xs hidden-sm">
                    <div className="with-tooltip" data-tooltip="Ready to show off your registry? Switch the toggle to &quot;Yes&quot; and anyone will be able to see it. Not ready yet? Keep the toggle on &quot;No.&quot;"><span className="margin-right-2x registry-visible">Visible to Guests?</span>
                      <div className="toggle-button-inline website-registry-toggle-btn">
                        <Toggle
                          checked={registryPublished}
                          onChange={this.onToggleRegistryPublish}
                          className="toggle-small toggle-red"
                          icons={{ checked: <span className="toggle-label checked registry-hidden-toggle">Yes</span>, unchecked: <span className="toggle-label unchecked registry-visible-toggle">No</span> }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
        <ul className="sortable-list">
          {registries && orderedIds.map((registryId, index) => (
            <Registry registry={registries[registryId]} onEdit={onEdit} onDelete={onDelete} index={index} key={registryId} />
          ))}
        </ul>
      </div>
    );
  }
}

Registries.propTypes = {
  registries: PropTypes.shape({}),
  orderedIds: PropTypes.arrayOf(PropTypes.number),
  getRegistry: PropTypes.func.isRequired,
  getRegistryEntities: PropTypes.func.isRequired,
  onToggleRegistryPublish: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  unloadEntities: PropTypes.func.isRequired,
  page: PropTypes.shape({}),
  hasRegistry: PropTypes.bool,
  themeKey: PropTypes.string,
  onPageToggle: PropTypes.func,
  slug: PropTypes.string,
  registry: PropTypes.shape({
    is_public: PropTypes.bool
  }),
  setShippingAddress: PropTypes.func.isRequired,
  moduleGroup: PropTypes.shape({
    modulesViews: PropTypes.arrayOf(PropTypes.shape({}))
  }),
  getModules: PropTypes.func,
};

const mapStateToProps = state => ({
  dashboard: state.dashboard,
  registry: state.registry,
  registries: state.website.entities.byId,
  orderedIds: state.website.entities.orderedIds,
  page: state.website.pages.byId[state.website.pages.typeToId.REGISTRY],
  hasRegistry: state.user.userContext.registry_ids.length > 0,
  themeKey: state.wedding.theme.key,
  slug: state.wedding.wedding.slug,
  moduleGroup: state.moduleGroup['weddings-website-registry-page'] || {},
});

const mapDispatchToProps = dispatch => ({
  getModules: () => dispatch(fetchModuleGroup('weddings-website-registry-page')),
  onSortEnd: ({ oldIndex, newIndex }) => dispatch(moveEntity(oldIndex, newIndex)),
  openModal: () => {
    dispatch(addEntity());
    dispatch(showModal('REGISTRY', {}, { size: 'md' }));
  },
  getRegistryEntities: () => dispatch(getRegistries()),
  onEdit: (registry) => {
    dispatch(editRegistry(registry));
    dispatch(showModal('REGISTRY', { isUpdate: true }, { size: 'md' }));
  },
  onDelete: entity => dispatch(showModal('DELETE_ENTITY', { entity })),
  unloadEntities: () => dispatch(resetEntities()),
  getRegistry: () => dispatch(fetchRegistry()),
  onPageToggle: pageId => dispatch(togglePage(pageId)),
  onToggleRegistryPublish: (value) => {
    if (value) {
      return dispatch(updateRegistryPublish(value)).then(() => dispatch(showModal('PUBLISH_REGISTRY', {}, { size: 'md' })));
    }
    return dispatch(updateRegistryPublish(value));
  },
  setShippingAddress: () => dispatch(showModal('SET_SHIPPING_ADDRESS', {}, { size: 'md' })),
});

const SortableRegistries = SortableContainer(Registries);

const RegistriesContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(SortableRegistries);

export default RegistriesContainer;



// WEBPACK FOOTER //
// ./src/components/manage/website/entities/Registry.jsx